"use client";
import React, { useEffect, useState } from "react";
import { Snackbar, Button, Alert } from "@mui/material";

export default function VersionUpdater() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const currentVersion = process.env.NEXT_PUBLIC_BUILD_NUMBER;

  useEffect(() => {
    if (!currentVersion) return;

    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json?t=" + new Date().getTime());
        if (response.ok) {
          const data = await response.json();
          if (data.version && data.version !== currentVersion) {
            setNewVersionAvailable(true);
          }
        }
      } catch (error) {
        console.error("Failed to check version", error);
      }
    };

    // Check immediately
    checkVersion();

    // Check every 5 minutes
    const interval = setInterval(checkVersion, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [currentVersion]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Snackbar
      open={newVersionAvailable}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity="info"
        action={
          <Button color="inherit" size="small" onClick={handleRefresh}>
            Refresh
          </Button>
        }
        sx={{ width: "100%" }}
      >
        A new version is available!
      </Alert>
    </Snackbar>
  );
}
